import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {User} from "../../models/user.model";
import {UserService} from "../../providers/user.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-vetineo-header',
  templateUrl: './vetineo-header.component.html',
  styleUrls: ['./vetineo-header.component.scss'],
})
export class VetineoHeaderComponent implements OnInit, OnDestroy {
  user: User;
  private userSub: Subscription;
  showPartnerLogo: boolean;
  @Input()
  pageName: string;

  constructor(private userService: UserService) {
  }

  ngOnInit() {
    this.userSub = this.userService.getUser().subscribe(it => {
      this.user = it;
      if(it?.isPartnerType){
        this.showPartnerLogo=true;
      } else {
        this.showPartnerLogo = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
  }

}
